import { LOYALTY_TIER } from 'modules/loyalty/constants'
import isAccountRegisterUrlLocationUtil from 'utils/location/is-account-register-url'
import isAccountLoginUrlLocationUtil from 'utils/location/is-account-login-url'
import isPostSampleSurveyUrlLocationUtil from 'utils/location/is-post-sample-survey'

/**
 * @param props
 * @param props.isFastTrackExpiringSoon
 * @param props.isFastTrackExpired
 * @param props.nextTierName
 * @return {boolean}
 */
export default function shouldShowFastTrackExpiryLoyaltySelectUtil (props) {
  const {
    isFastTrackExpiringSoon,
    isFastTrackExpired,
    nextTierName
  } = props

  const isPostSampleSurveyUrl = isPostSampleSurveyUrlLocationUtil()
  const isRegisterOrLoginUrl = (
    isAccountRegisterUrlLocationUtil() ||
    isAccountLoginUrlLocationUtil()
  )

  const isAllowedUrl = !isPostSampleSurveyUrl && isRegisterOrLoginUrl
  const isFastTrackingToGoldOrDiamond = [
    LOYALTY_TIER.GOLD,
    LOYALTY_TIER.DIAMOND
  ].includes(nextTierName)
  return (
    !isAllowedUrl &&
    isFastTrackExpiringSoon &&
    !isFastTrackExpired &&
    isFastTrackingToGoldOrDiamond
  )
}
